import {axios} from '../utils/request'
import Vue from 'vue'

const api = {
  clientId: 'client_longji',
  clientSecret: 'longji-secret'
}

/**
 * OAuth2 构建授权登录地址
 *
 * @param form 表单DOM对象
 * @param redirect 重定向地址，可选
 */
export function login(form, redirect = '') {
  return new Promise((resolve,reject) => {
    redirect = encodeURIComponent(redirect);
    form.action = `${process.env.VUE_APP_API_BASE_URL}/oauth/authorization?response_type=code&client_id=${api.clientId}&action=dologin&redirect_uri=${redirect}`
    form.method = 'post';
    form.submit();
    resolve()
  })
}

export function bifactorLogin(loginName,loginPwd,key1,key2) {
  return axios.post('/oauth/authorization', null, {
    params: {
      response_type: 'code',
      client_id: api.clientId,
      action: 'doBifactor',
      loginName:loginName,
      loginPwd:loginPwd,
      key1:key1,
      key2:key2,
    }
  })
}

export function refreshToken(refreshToken) {
  return axios.post('/oauth/access', null, {
    headers: {
      action: 'grant_refresh',
      'Content-Type': 'application/x-www-form-urlencoded',
      'refresh_token': refreshToken
    },
    params: {
      grant_type: 'authorization_code',
      client_id: api.clientId,
      client_secret: api.clientSecret,
      code: Math.random(),
      redirect_uri: '#'
    }
  })
}

export function getToken(code) {
  return axios.post('/oauth/access', null, {
    headers: {
      action: 'grant_auth',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params: {
      grant_type: 'authorization_code',
      client_id: api.clientId,
      client_secret: api.clientSecret,
      code: code,
      redirect_uri: '#'
    }
  })
}

export function qrToken(code, uuid) {
  return axios.get('/qr/hand', {
    params: {
      code: code,
      qrcode_uuid: uuid
    }
  })
}

export function switchDept(dept) {
  return axios.post('/oauth/authorization', null, {
    params: {
      response_type: 'code',
      client_id: api.clientId,
      action: 'switchdept',
      depart_uuid: dept
    }
  })
}

export function getRsaPublicKey() {
  // return '';
  return axios.get('/oauth/rsaKey')
}

export function getUserInfo() {
  return axios.post('/oauth/getUserInfo')
}

export function logout() {
  return axios.post('/oauth/authorization', null, {
    params: {
      response_type: 'code',
      client_id: api.clientId,
      action: 'logout'
    }
  })
}

/**
 * 登录请求,已登录的情况下内部应用间的单点登录跳转
 * @param redirect    登录回调地址(必填)
 */
export function loginRedirect(redirect,target="_blank"){
  if(!redirect || redirect === ''){
    console.error("登录请求,登录回调地址参数不能为空！");
  }

  if(Vue.ss.get('token')){
    subLoginRedirect(redirect,target)
  }else if (!Vue.ss.get('token') && Vue.ss.get('refresh_token')) {
    refreshToken(Vue.ss.get('refresh_token')).then(d => {
      Vue.ss.set('token', d.access_token, d.expires_in * 1000)
      Vue.ss.set('refresh_token', d.refresh_token, 3600 * 24 * 1000)
      setTimeout(()=>{
        subLoginRedirect(redirect,target)
      })
    });
  }else{
    console.error("登录请求,当前处理未登录状态，无法进行登录认证！");
  }
}

export function subLoginRedirect(redirect,target="_blank"){
  const form = document.createElement('form');
  document.body.appendChild(form);
  form.action = `${process.env.VUE_APP_API_BASE_URL}/oauth/authorization?token=${Vue.ss.get('token')}&response_type=code&client_id=${api.clientId}&action=login&redirect_uri=${redirect}`;
  form.method = 'post';
  form.target = target;
  form.submit();
}